import React from "react";
import "./styles.scss";

const GiveawayMastheadImageasImg: React.FC<any> = ({
  backgroundImage,
  mobilebackground,
  title,
}) => {

  return (
    <>
      <img src={backgroundImage} className="desktop-bg" alt={title} /> 
      <img src={mobilebackground} className="mobile-bg" alt={title} /> 
    </>
  );
};

export default GiveawayMastheadImageasImg;
